// extracted by mini-css-extract-plugin
export default {"peppol-code":"PeppolCode_peppol-code__VBrYr","peppol-code__info":"PeppolCode_peppol-code__info__UHfgF","peppol-code__tooltip":"PeppolCode_peppol-code__tooltip__FOnYm"};